export const CONSENT_VERSION = '2026-07-24';
export const CONSENT_STORAGE_KEY = 'adpulseConsentV1';
const CORE_FONT_LINK_ID = 'adpulse-consented-fonts';
const CORE_FONT_URL = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Outfit:wght@500;600;700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Caveat:wght@500;700&family=Dancing+Script:wght@500;700&display=swap';

export const DEFAULT_CONSENT = {
  version: CONSENT_VERSION,
  necessary: true,
  functional: false,
  analytics: false,
  marketing: false,
  action: '',
  savedAt: '',
};

export function loadConsent() {
  try {
    const parsed = JSON.parse(localStorage.getItem(CONSENT_STORAGE_KEY) || 'null');
    if (!parsed || parsed.version !== CONSENT_VERSION || !parsed.savedAt) return null;
    return { ...DEFAULT_CONSENT, ...parsed, necessary: true };
  } catch (error) {
    return null;
  }
}

export function applyConsentResources(consent) {
  const existing = document.getElementById(CORE_FONT_LINK_ID);
  if (!consent?.functional) {
    existing?.remove();
    return;
  }
  if (!existing) {
    const link = document.createElement('link');
    link.id = CORE_FONT_LINK_ID;
    link.rel = 'stylesheet';
    link.href = CORE_FONT_URL;
    document.head.appendChild(link);
  }
}

export function saveConsent(preferences, action = 'save_preferences') {
  const next = {
    ...DEFAULT_CONSENT,
    ...preferences,
    version: CONSENT_VERSION,
    necessary: true,
    action,
    savedAt: new Date().toISOString(),
  };
  localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(next));
  if (!next.functional) {
    Object.keys(localStorage)
      .filter((key) => (
        key === 'adpulsePreferences'
        || key.startsWith('adpulsePreferences:')
        || key.startsWith('adpulse.tutorial-progress.')
        || key === 'onboardingDismissed'
      ))
      .forEach((key) => localStorage.removeItem(key));
    document.querySelectorAll('link[id^="font-"][href*="fonts.googleapis.com"]').forEach((link) => link.remove());
  }
  applyConsentResources(next);
  window.dispatchEvent(new CustomEvent('adpulse:consent-changed', { detail: next }));
  return next;
}

export function isConsentGranted(category) {
  if (category === 'necessary') return true;
  return Boolean(loadConsent()?.[category]);
}
